<!-- Básica -->
<div class="row" *ngIf="isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 22 (%)</mat-label>
                                <input matInput id="txtRetPenViDoisPrc" #txtRetPenViDoisPrc maxlength="6"
                                    formControlName="retido_peneira_vinte_dois_prc" currencyMask
                                    (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenViDoisPrc.value.length}} / 10</mat-hint>
                                 <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_vinte_dois_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                              floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Retido Peneira 20 (%)</mat-label>
                              <input matInput id="txtRetPenViPrc" #txtRetPenViPrc maxlength="6"
                                  formControlName="retido_peneira_vinte_prc" currencyMask (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                              <i matSuffix class="{{iconEnableField}}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtRetPenViPrc.value.length}} / 10</mat-hint>
                              <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_vinte_prc)}}
                              </mat-error>
                          </mat-form-field>
                      </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 18 (%)</mat-label>
                                <input matInput id="txtRetPenDezoPrc" #txtRetPenDezoPrc maxlength="6"
                                    formControlName="retido_peneira_dezoito_prc" currencyMask
                                    (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenDezoPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_dezoito_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                              floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Retido Peneira 16 (%)</mat-label>
                              <input matInput id="txtRetPenDezessPrc" #txtRetPenDezessPrc maxlength="6"
                                  formControlName="retido_peneira_dezesseis_prc" (blur)="makeCalculations()" currencyMask [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                              <i matSuffix class="{{iconEnableField}}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtRetPenDezessPrc.value.length}} / 10</mat-hint>
                              <mat-error>
                                  {{hasErrorFormControl(formulario.controls.retido_peneira_dezesseis_prc)}}
                              </mat-error>
                          </mat-form-field>
                      </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 15 (%)</mat-label>
                                <input matInput id="txtRetPenQuinzePrc" #txtRetPenQuinzePrc maxlength="6"
                                    formControlName="retido_peneira_quinze_prc" (blur)="makeCalculations()" currencyMask [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenQuinzePrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_quinze_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira R3 (%)</mat-label>
                                <input matInput id="txtRetPenR3Prc" #txtRetPenR3Prc maxlength="6"
                                    formControlName="retido_peneira_r3_prc" (blur)="makeCalculations()" currencyMask [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenR3Prc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_r3_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>

                    <div class="row pt-3">

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado Retenção</mat-label>
                                <input matInput id="txtResRet" #txtResRet maxlength="100"
                                    formControlName="resultado_retencao" readonly class="InputBlockColor" [ngClass]="{'InputBlockColor': formulario.disabled}">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtResRet.value.length}} / 100</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.resultado_retencao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Vazado Peneira Corresp Furo Redondo (%)</mat-label>
                                <input matInput id="txtVazPenCorrespFuroRedPrc" #txtVazPenCorrespFuroRedPrc
                                    maxlength="10" formControlName="vazado_peneira_corresp_furo_redondo_prc"
                                    currencyMask (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100" >
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtVazPenCorrespFuroRedPrc.value.length}} / 10</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.vazado_peneira_corresp_furo_redondo_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<!-- Comercial -->
<div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 22 (%)</mat-label>
                                <input matInput id="txtRetPenViDoisPrc" #txtRetPenViDoisPrc maxlength="6"
                                    formControlName="retido_peneira_vinte_dois_prc" currencyMask
                                    (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenViDoisPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_vinte_dois_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 21 (%)</mat-label>
                                <input matInput id="txtRetPenViUmPrc" #txtRetPenViUmPrc maxlength="6"
                                    formControlName="retido_peneira_vinte_um_prc" currencyMask
                                    (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenViUmPrc.value.length}} / 10</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.retido_peneira_vinte_um_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 20 (%)</mat-label>
                                <input matInput id="txtRetPenViPrc" #txtRetPenViPrc maxlength="6"
                                    formControlName="retido_peneira_vinte_prc" currencyMask (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenViPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_vinte_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 19 (%)</mat-label>
                                <input matInput id="txtRetPenDezePrc" #txtRetPenDezePrc maxlength="6"
                                    formControlName="retido_peneira_dezenove_prc" currencyMask
                                    (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenDezePrc.value.length}} / 10</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.retido_peneira_dezenove_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 18 (%)</mat-label>
                                <input matInput id="txtRetPenDezoPrc" #txtRetPenDezoPrc maxlength="6"
                                    formControlName="retido_peneira_dezoito_prc" currencyMask
                                    (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenDezoPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_dezoito_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 17 (%)</mat-label>
                                <input matInput id="txtRetPenDezesPrc" #txtRetPenDezesPrc maxlength="6"
                                    formControlName="retido_peneira_dezessete_prc" currencyMask [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenDezesPrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_dezessete_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 16 (%)</mat-label>
                                <input matInput id="txtRetPenDezessPrc" #txtRetPenDezessPrc maxlength="6"
                                    formControlName="retido_peneira_dezesseis_prc" currencyMask [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenDezessPrc.value.length}} / 10</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.retido_peneira_dezesseis_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Retido Peneira 15 (%)</mat-label>
                                <input matInput id="txtRetPenQuinzePrc" #txtRetPenQuinzePrc maxlength="6"
                                    formControlName="retido_peneira_quinze_prc" currencyMask [ngClass]="{'InputBlockColor': formulario.disabled}" max="100">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRetPenQuinzePrc.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.retido_peneira_quinze_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Vazado Peneira Corresp Furo Redondo (%)</mat-label>
                                <input matInput id="txtVazPenCorrespFuroRedPrc" #txtVazPenCorrespFuroRedPrc
                                    maxlength="10" formControlName="vazado_peneira_corresp_furo_redondo_prc"
                                    currencyMask (blur)="makeCalculations()" [ngClass]="{'InputBlockColor': formulario.disabled}" max="100" >
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtVazPenCorrespFuroRedPrc.value.length}} / 10</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.vazado_peneira_corresp_furo_redondo_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado Retenção</mat-label>
                                <input matInput id="txtResRet" #txtResRet maxlength="100"
                                    formControlName="resultado_retencao" readonly [ngClass]="{'InputBlockColor': formulario.disabled}"
                                    [ngStyle]="{'background-color': formulario.controls.resultado_retencao.value ==='Aprovado' ? 'green' : 'red'  } ">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtResRet.value.length}} / 100</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.resultado_retencao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

